<template>
  <div>
    <filters v-model="filterForm" @input="fetchFeedbackData()"/>
    <pagination-elem
        v-if="pagination.count > 1"
        :pagination="pagination"
        @change="fetchFeedbackData"/>
    <table-list
        :feedbackData="feedbackData"
        :statuses="statuses"
        :sort="sorting"
        @sort="sortHandler"
        @refresh-requests="fetchFeedbackData"
        :loading="loading"
    />
  </div>
</template>

<script>
import TableList from "./components/table.vue";
import PaginationElem from "@/components/pagination/index.vue";
import Filters from "./components/filters.vue";
import { deepCopy } from "@/helper";

export default {
  name: "feedback",
  components: {Filters, TableList, PaginationElem},
  data() {
    return {
      feedbackData: [],
      loading: false,
      pagination: {},
      statuses: [],
      sorting: deepCopy({
        created_at: 'desc',
      }),
      filterForm: {
        created_at: {
          from: null,
          to: null,
        },
        search: {},
      },
    };
  },
  created() {
    this.fetchFeedbackData();
  },
  methods: {
    async fetchFeedbackData() {
      try {
        this.loading = true;

        const payload = {
          ...this.filterForm,
          sorting: this.sorting,
          pagination: {
            page: this.pagination.page - 1,
            limit: this.pagination.limit,
          },
        };
        const {
          data: {data, meta},
        } = await this.$http.post("/feedbacks", payload);
        this.feedbackData = data;
        this.pagination = meta.pagination;
        this.statuses = meta.feedback_statuses;
        this.pagination.page = this.pagination.page + 1;
      } catch (e) {
        this.$errorMessage(
            e.response?.data?.message || "Error! Something went wrong"
        );
      } finally {
        this.loading = false;
      }
    },

    sortHandler(value) {
      // clean other sorting
      for (let val in this.sorting) if (val !== value) this.sorting[val] = null;

      // clean on the third click
      if (this.sorting[value] === "asc") {
        this.sorting[value] = null;
        this.fetchFeedbackData();
        return;
      }

      this.sorting[value] === "desc"
        ? (this.sorting[value] = "asc")
        : (this.sorting[value] = "desc");
      this.fetchFeedbackData();
    },
  },
};
</script>

<style scoped></style>
